import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import PageRemarks from 'Pages/remarks';
import PageRemark from 'Pages/remark';

const Home = ({ match }) => (
	<div className="dashboard-wrapper">
		<Switch>
			<Redirect exact from={`${match.url}/`} to={`${match.url}/list`} />
			<Route exact path={`${match.url}/list`} component={ PageRemarks } />
			<Route exact path={`${match.url}/create`} component={ PageRemark } />
			<Route exact path={`${match.url}/edit/:remarkId`} component={ PageRemark } />
			<Redirect to="/error" />
		</Switch>
	</div>
);
export default Home;